import cardioProtocolPdf from '../../assets/docs/Protocolo_de_Cardio_Cavalaria_Mari_Mosca.pdf';
import nutritionalProtocolPdf from '../../assets/docs/Protocolo_Nutricional_Cinta_Natural_Mari Mosca.pdf';
import heroBackgroundImage from '../../assets/images/marketing_projects/cinta_natural/capa.jpeg';
import stepOneImage from '../../assets/images/marketing_projects/cinta_natural/passo_01.jpg';
import stepTwoImage from '../../assets/images/marketing_projects/cinta_natural/passo_02.jpg';
import stepThreeImage from '../../assets/images/marketing_projects/cinta_natural/passo_03.jpg';
import stepFourImage from '../../assets/images/marketing_projects/cinta_natural/passo_04.png';
import stepFiveImage from '../../assets/images/marketing_projects/cinta_natural/passo_05.jpg';
import {
  LANDPAGE_COMMUNITY_LINKS,
  LANDPAGE_HERO,
  type LandpageStepImagePosition,
  type OnboardingHeroCopy,
} from '../Landpage/landpage.constants';

export const CINTA_NATURAL_HERO: OnboardingHeroCopy = {
  backgroundImageSrc: heroBackgroundImage,
  backgroundImageAlt: 'Aluna do Movimento Cinta Natural',
  backgroundImagePosition: 'top',
  backgroundImageTopCrop: 150,
  titleLineOne: 'SEJA BEM-VINDA AO',
  titleLineTwo: 'MOVIMENTO CINTA NATURAL',
  bottomMessageLineOne:
    'É um prazer enorme ter você aqui com a gente. A partir de agora, começamos juntas um processo para construir um corpo mais forte, preparado e livre.',
  bottomMessageLineTwo: 'Vamos começar? Assista ao vídeo abaixo.',
  supportButtonLabel: LANDPAGE_HERO.supportButtonLabel,
  supportWhatsAppUrl: LANDPAGE_HERO.supportWhatsAppUrl,
};

export const CINTA_NATURAL_WELCOME_VIDEO = {
  title: 'Vídeo de Boas-vindas',
  videoUrl: 'https://youtu.be/X_4BiK9Jd0A',
  embedUrl: 'https://www.youtube.com/embed/X_4BiK9Jd0A',
} as const;

export const CINTA_NATURAL_STEPS_TITLE = 'Seu passo a passo no Movimento';

interface CintaNaturalStepItem {
  title: string;
  paragraphs: readonly string[];
  actionLabel: string;
  actionHref?: string;
}

export interface CintaNaturalStep {
  id: '01' | '02' | '03' | '04' | '05';
  title: string;
  paragraphs: readonly string[];
  imageSrc: string;
  imageAlt: string;
  imagePosition: LandpageStepImagePosition;
  imageObjectPosition?: string;
  imageRightCropPx?: number;
  actionLabel?: string;
  actionHref?: string;
  items?: readonly CintaNaturalStepItem[];
}

export const CINTA_NATURAL_STEPS: readonly CintaNaturalStep[] = [
  {
    id: '01',
    title: 'COMECE POR AQUI',
    paragraphs: [
      'Antes de qualquer coisa, assista ao vídeo acima.',
      'Nele, vou explicar como funciona o Movimento Cinta Natural, o que preparamos para você e, principalmente, como aproveitar tudo a que terá acesso a partir de agora.',
      'Depois do vídeo, siga os passos abaixo.',
    ],
    imageSrc: stepOneImage,
    imageAlt: 'Aluna iniciando o Movimento Cinta Natural',
    imagePosition: 'right',
  },
  {
    id: '02',
    title: 'ACESSE O CONTEÚDO EXCLUSIVO CINTA NATURAL',
    paragraphs: [
      'Dentro do MariFlix, você encontrará uma área exclusiva do Movimento Cinta Natural.',
      'Preparei aulas curtas e práticas para ajudar você a entender melhor o seu corpo e aplicar esse conhecimento no treino: respiração, ativação do abdômen, estabilidade, postura, diástase e muito mais.',
      'E, toda semana, teremos um conteúdo novo por lá.',
      'Não é preciso assistir a tudo de uma vez.',
      'Comece pela primeira aula, coloque em prática a ação proposta e avance com a gente.',
    ],
    imageSrc: stepTwoImage,
    imageAlt: 'Conteúdo exclusivo do Movimento Cinta Natural',
    imagePosition: 'left',
    actionLabel: 'ACESSAR MOVIMENTO CINTA NATURAL',
  },
  {
    id: '03',
    title: 'BAIXE SEUS PROTOCOLOS',
    paragraphs: [
      'Além do seu treino individualizado, preparamos dois materiais para complementar o seu processo.',
    ],
    imageSrc: stepThreeImage,
    imageAlt: 'Protocolos do Movimento Cinta Natural',
    imagePosition: 'right',
    imageObjectPosition: 'right center',
    imageRightCropPx: 50,
    items: [
      {
        title: 'PROTOCOLO NUTRICIONAL',
        paragraphs: [
          'Orientações desenvolvidas pela nossa equipe de nutrição para ajudar você a organizar sua alimentação durante o Movimento.',
        ],
        actionLabel: 'BAIXAR PROTOCOLO NUTRICIONAL',
        actionHref: nutritionalProtocolPdf,
      },
      {
        title: 'PROTOCOLO DE CARDIO',
        paragraphs: [
          'Orientações para incluir o cardio na sua rotina e complementar o trabalho que já faremos no treinamento.',
        ],
        actionLabel: 'BAIXAR PROTOCOLO DE CARDIO',
        actionHref: cardioProtocolPdf,
      },
    ],
  },
  {
    id: '04',
    title: 'ENTRE PARA A NOSSA COMUNIDADE',
    paragraphs: [
      'Você não precisa fazer esse processo sozinha.',
      'Entre para a comunidade exclusiva das nossas alunas para acompanhar conteúdos, avisos, novidades e tudo o que estiver acontecendo por aqui.',
    ],
    imageSrc: stepFourImage,
    imageAlt: 'Comunidade exclusiva das alunas',
    imagePosition: 'left',
    actionLabel: 'ENTRAR NA COMUNIDADE',
    actionHref: LANDPAGE_COMMUNITY_LINKS.communityUrl,
  },
  {
    id: '05',
    title: 'ENTRE PARA O GRUPO DO PODCAST',
    paragraphs: [
      'Tem mais uma coisa :)',
      'Temos um grupo exclusivo no qual compartilhamos episódios, reflexões e conteúdos do nosso podcast diretamente com as alunas.',
    ],
    imageSrc: stepFiveImage,
    imageAlt: 'Grupo exclusivo do podcast',
    imagePosition: 'right',
    actionLabel: 'ENTRAR NO GRUPO DO PODCAST',
    actionHref: LANDPAGE_COMMUNITY_LINKS.podcastsUrl,
  },
] as const;

export const CINTA_NATURAL_FINAL_MESSAGE = {
  title: 'PRONTO. AGORA É COMEÇAR',
  paragraphs: [
    'Seu treino é individualizado.',
    'Você tem suporte e pode enviar seus vídeos para correção.',
    'Tem uma equipe acompanhando o seu processo.',
    'E agora também tem acesso a todo o conteúdo do Movimento Cinta Natural para ajudar você a entender e usar melhor o seu corpo.',
    'Mas nada disso funciona se ficar apenas aqui dentro.',
    'Assista. Aplique. Treine. Pergunte. Envie seus vídeos. Participe.',
    'Nós damos a direção.',
    'A construção acontece junto com você.',
    'Bem-vinda ao Movimento Cinta Natural.',
  ],
} as const;
